import { WalletNetworkInfo } from 'ui/types/wallet';
import { NetworkNameTechnicalEnum, NetworkTypeEnum } from 'api';

export const getWalletAddressForNetwork = (
  networkType: NetworkTypeEnum,
  wallet: WalletNetworkInfo,
): string | undefined | null => {
  switch (networkType) {
    case NetworkTypeEnum.ETHEREUM:
      return wallet.ethInfo?.address;
    case NetworkTypeEnum.STELLAR:
      return wallet.stellarInfo?.accountId;
  }
};

export const getNetworkTypeName = (networkType: NetworkTypeEnum) => {
  switch (networkType) {
    case NetworkTypeEnum.ETHEREUM:
      return 'Ethereum';
    case NetworkTypeEnum.STELLAR:
      return 'Stellar';
    default:
      return '';
  }
};

export const getWalletAddressForNetworkAssertExistence = (
  networkType: NetworkTypeEnum,
  wallet: WalletNetworkInfo,
): string => {
  switch (networkType) {
    case NetworkTypeEnum.ETHEREUM:
      if (!wallet.ethInfo?.address) {
        throw new Error('no wallet address for NetworkType.ETHEREUM');
      }
      return wallet.ethInfo?.address;
    case NetworkTypeEnum.STELLAR:
      if (!wallet.stellarInfo?.accountId) {
        throw new Error('no wallet accountId for NetworkType.STELLAR');
      }
      return wallet.stellarInfo?.accountId;
  }
};

export const getNetworkType = (network: NetworkNameTechnicalEnum): NetworkTypeEnum => {
  switch (network) {
    case NetworkNameTechnicalEnum.ETH_DEV:
    case NetworkNameTechnicalEnum.ETH_MAINNET:
    case NetworkNameTechnicalEnum.ETH_SEPOLIA:
    case NetworkNameTechnicalEnum.ETH_TEST:
    case NetworkNameTechnicalEnum.POLYGON_AMOY:
    case NetworkNameTechnicalEnum.POLYGON_MAINNET:
      return NetworkTypeEnum.ETHEREUM;
    case NetworkNameTechnicalEnum.STELLAR_DEV:
    case NetworkNameTechnicalEnum.STELLAR_PUBNET:
    case NetworkNameTechnicalEnum.STELLAR_TEST:
    case NetworkNameTechnicalEnum.STELLAR_TESTNET:
      return NetworkTypeEnum.STELLAR;
  }

  return NetworkTypeEnum.ETHEREUM;
};
